module.exports = __webpack_public_path__ + "static/media/login-background.a3f45968.jpg";